import { a0 as r, a1 as a } from "../../vendor-EQDp64ng.js";
import { useMemo as m } from "react";
import { isEqual as i } from "./isEqual.js";
function n(t) {
  const e = r(t ?? {}, i), { locale: o } = a();
  return m(() => new Intl.RelativeTimeFormat(o, e), [o, e]);
}
export {
  n as useRelativeTimeFormatter
};
